export default __webpack_public_path__ + "static/logo-sony-pictures-1b1336e1ab0b76a2e3827e42dd9598c1.png";